import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { Client, ClientSingleResponse, StoreClientRequest } from '@lib/api/models/client';
import { ClientService } from '@lib/client/client.service';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { ComponentsModule, DialogService, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';

@Component({
    selector: 'app-prompt-client-status-change-dialog',
    imports: [ComponentsModule, ErrorPanelComponent],
    templateUrl: './prompt-client-status-change-dialog.component.html',
    standalone: true,
    styleUrl: './prompt-client-status-change-dialog.component.scss'
})
export class PromptClientStatusChangeDialogComponent {
    protected readonly dialogRef = inject<DialogRef>(DialogRef);
    private readonly _clientService = inject(ClientService);
    private readonly _snackBar = inject(SnackBarService);
    protected readonly client = inject<Client>(DIALOG_DATA);

    updateClientRequest = new SendableRequest<ClientSingleResponse, StoreClientRequest>({
        request: (payload) => this._clientService.updateClient(this.client.id, payload!),
        onSuccess: () => {
            this._snackBar.open({
                colour: 'success',
                dismissable: false,
                icon: 'check_circle',
                title: 'Client status changed successfully',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });
            this.dialogRef.close();
        },
        onError: () => {
            this._snackBar.open({
                colour: 'error',
                dismissable: false,
                icon: 'error_outline',
                title: 'Client status failed to change',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });
        }
    });

    update() {
        this.updateClientRequest.send({
            status: this.client.status,
            reference: this.client.reference,
            nhs_number: this.client.nhs_number,
            email: this.client.email,
            person: {
                title: this.client.person.title,
                given_name: this.client.person.given_name,
                initials: this.client.person.initials,
                family_name: this.client.person.family_name,
                middle_names: this.client.person.middle_names,
                preferred_name: this.client.person.preferred_name,
                birth_sex: this.client.person.birth_sex,
                pronouns: this.client.person.pronouns,
                date_of_birth: this.client.person.date_of_birth,
                additional_comments: this.client.person.additional_comments
            }
        });
    }


    public static show(dialog: DialogService, data: Client) {
        return dialog.openDialog<DialogRef, Client>(PromptClientStatusChangeDialogComponent, {
                data
            }
        );
    }

}
